let body = document.querySelector('body');

// CallTouch
setTimeout(function () {
    (function(w,d,n,c){w.CalltouchDataObject=n;w[n]=function(){w[n]["callbacks"].push(arguments)};if(!w[n]["callbacks"]){w[n]["callbacks"]=[]}w[n]["loaded"]=false;if(typeof c!=="object"){c=[c]}w[n]["counters"]=c;for(var i=0;i<c.length;i+=1){p(c[i])}function p(cId){var a=d.getElementsByTagName("script")[0],s=d.createElement("script"),i=function(){a.parentNode.insertBefore(s,a)};s.type="text/javascript";s.async=true;s.src="https://mod.calltouch.ru/init.js?id="+cId;if(w.opera=="[object Opera]"){d.addEventListener("DOMContentLoaded",i,false)}else{i()}}})(window,document,"ct","l0tivktc");
}, 1000);

// Yandex Metrika
setTimeout(function () {
    (function(m,e,t,r,i,k,a){ m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    ym(38548635, "init", { }); // ABS-Auto
    ym(68935834, "init", { webvisor: true });
}, 2000);

// Google Analytics
setTimeout(function () {
    // MBR
    let googleMBR = document.createElement('script');
    googleMBR.src = "https://www.googletagmanager.com/gtag/js?id=UA-154162427-1";
    googleMBR.async = true;
    // ABS-Auto
    let googleABS= document.createElement('script');
    googleABS.src = "https://www.googletagmanager.com/gtag/js?id=UA-192232937-1";
    googleABS.async = true;

    body.appendChild(googleMBR);
    body.appendChild(googleABS);

    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-154162427-1');
    gtag('config', 'UA-192232937-1');

}, 3000);

// Callkeeper
/*
setTimeout(function () {
    let callkeeper = document.createElement('script');
    callkeeper.async = true;
    callkeeper.src = '//callkeeper.ru/w/?6f85ef5b';

    let callkeeperVip = document.createElement('script');
    callkeeperVip.src = 'https://vip.callkeeper.ru/js/sales.mercedes-sochi';


    body.appendChild(callkeeper);
    body.appendChild(callkeeperVip);

}, 5000);*/


